import PropTypes from 'prop-types';
// @mui
import { Typography, Stack, Box, useTheme } from '@mui/material';
// components
import Logo from '../../components/logo';
import Image from '../../components/image';
//
import { StyledRoot, StyledSectionBg, StyledSection, StyledContent } from './styles';
// locales
import { useLocales } from '../../locales';

// ----------------------------------------------------------------------

LoginLayout.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  illustration: PropTypes.string,
};

export default function LoginLayout({ children, illustration, title }) {
  const theme = useTheme();
  const { translate } = useLocales();

  return (
    <StyledRoot>
      {/* <Logo
        sx={{
          zIndex: 9,
          position: 'absolute',
          mt: { xs: 1.5, md: 5 },
          ml: { xs: 2, md: 5 },
        }}
      /> */}

      <StyledSection>
      {/* <Box sx={{ backgroundColor:'#1a1b1d47', padding:'41px', borderRadius:'20px' }}> */}
        <Image
          disabledEffect
          visibleByDefault
          alt="auth"
          // src={illustration || '/assets/illustrations/characters/character_7.png'}
          src={illustration || '/assets/logos/C2C_logo.svg'}
          // sx={{ maxWidth: 720 }}
          // sx={{ mb: "100px" }}
          sx={{ mb: "170px" }}
          overflow="visible"
          height="230%"
        />

        <Typography variant="h2" sx={{ mb: 1, maxWidth: 480, textAlign: 'center', color: theme.palette.text.primary }}>
          {title || 'Click to Connect'}
        </Typography>

        <Typography variant="h3" sx={{ mb: 9, maxWidth: 480, textAlign: 'center', color: theme.palette.text.secondary }}>
          {/* {title || translate('login.welcome')} */}
          Administration
        </Typography>
        {/* </Box> */}

        <StyledSectionBg />
      </StyledSection>

      <StyledContent>
        <Stack sx={{ width: 1 }}> {children} </Stack>
      </StyledContent>
    </StyledRoot>
  );
}
